import { render, staticRenderFns } from "./SluzbaEshopyDetail.vue?vue&type=template&id=6567a8df&scoped=true&"
import script from "./SluzbaEshopyDetail.vue?vue&type=script&lang=js&"
export * from "./SluzbaEshopyDetail.vue?vue&type=script&lang=js&"
import style0 from "./SluzbaEshopyDetail.vue?vue&type=style&index=0&id=6567a8df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567a8df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6567a8df')) {
      api.createRecord('6567a8df', component.options)
    } else {
      api.reload('6567a8df', component.options)
    }
    module.hot.accept("./SluzbaEshopyDetail.vue?vue&type=template&id=6567a8df&scoped=true&", function () {
      api.rerender('6567a8df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/sluzby/SluzbaEshopyDetail.vue"
export default component.exports